export default {
    set: (state, payload) => {
        Object.assign(state, payload)
    }
}
